/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    FETCH_PUBLIC_REVIEWS_FAILURE,
    FETCH_PUBLIC_REVIEWS_START,
    FETCH_PUBLIC_REVIEWS_SUCCESS,
    PUBLIC_REVIEWS_RESET,
} from '../constants/types';

export const initialState = {
    // exclusive upper bound of loading data
    loading: 0,
    // inclusive upper bound of loaded data
    loaded: -1,
    error: null,
    data: [],
    startKey: '',
};

export function publicReviews(state = initialState, action) {
    switch (action.type) {
        case FETCH_PUBLIC_REVIEWS_START: {
            const { location_id, location_type } = action.payload;
            return {
                ...state,
                location_id,
                location_type,
                loading: state.loading + action.payload.pageSize,
            };
        }
        case FETCH_PUBLIC_REVIEWS_SUCCESS: {
            const data = action.payload.data ? action.payload.data : [];
            return {
                ...state,
                loaded: state.loading - 1,
                data: [...state.data, ...data],
                startKey: action.payload.startKey,
            };
        }
        case FETCH_PUBLIC_REVIEWS_FAILURE:
            return { ...state, loading: state.loaded + 1, error: action.payload.error };
        case PUBLIC_REVIEWS_RESET:
            return initialState;
        default:
            return state;
    }
}

export const publicReviewsSelector = (state) => state.ratingReviews.publicReviews;
